import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app/module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app/ducks';
import { ProgressCircular } from '@americanexpress/dls-react';
import childRoutes from '../childRoutes';
import Header from './Header';
const InvoiceManagementRoot = ({
  children,
  languageData,
  locale
}) => {
  if (Object.entries(languageData).length === 0) {
    return /*#__PURE__*/React.createElement(ProgressCircular, null);
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: languageData
  }, /*#__PURE__*/React.createElement("meta", {
    charSet: "utf-8"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    href: "https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    href: "https://www.americanexpress.com/favicon.ico"
  }), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement("main", null, children));
};
export const TestableInvoiceManagementRoot = InvoiceManagementRoot;

// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
InvoiceManagementRoot.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require, @typescript-eslint/no-require-imports -- require needs to be inside browser check
  InvoiceManagementRoot.appConfig = require('../appConfig').default;
}
export const loadModuleData = async ({
  store: {
    dispatch
  }
}) => dispatch(loadLanguagePack('invoice-management-root', {
  fallbackLocale: 'en-US'
}));
InvoiceManagementRoot.holocron = {
  name: 'invoice-management-root',
  loadModuleData
};
InvoiceManagementRoot.displayName = 'InvoiceManagementRoot';
export default oneAppModuleWrapper('invoice-management-root')(InvoiceManagementRoot);